// src/pages/ConferirDocumento/components/FormSection.js
import React from 'react';

const FormSection = ({
  tipoAnalise,
  setTipoAnalise,
  arquivo,
  onFileChange,
  onRemoverArquivo,
  onEnviar,
  loading,
  error
}) => {
  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    onFileChange(file);
  };

  return (
    <div className="conferir-form-section">
      <div className="form-group">
        <label className="field-label">
          <span>🔍</span>
          Tipo de Conferência
        </label>
        <select
          value={tipoAnalise}
          onChange={(e) => setTipoAnalise(e.target.value)}
          className="tipo-analise-select"
          disabled={loading}
        >
          <option value="CONFERENCIA_BASICA">Conferência Básica</option>
          <option value="CONFERENCIA_PROFUNDA">Conferência Profunda</option>
        </select>
      </div>

      <div className="form-group">
        <label className="field-label">
          <span>📄</span>
          Documento
        </label>
        <input
          type="file"
          accept=".pdf,.docx,.txt"
          onChange={handleFileInputChange}
          className="file-input"
          id="file-upload-conferir"
          disabled={loading}
        />
        <label
          htmlFor="file-upload-conferir"
          className={`file-upload-label ${arquivo ? 'has-file' : ''}`}
        >
          <span>📁</span>
          {arquivo ? arquivo.name : 'Selecionar Ficheiro (PDF, DOCX, TXT)'}
        </label>

        {arquivo && (
          <div className="arquivo-selecionado">
            <div className="arquivo-info">
              <span className="arquivo-icon">
                {arquivo.name.endsWith('.pdf') ? '📄' :
                 arquivo.name.endsWith('.docx') ? '📝' : '📃'}
              </span>
              <span className="arquivo-nome">{arquivo.name}</span>
              <span className="arquivo-tamanho">
                ({(arquivo.size / 1024).toFixed(1)} KB)
              </span>
            </div>
            <button
              type="button"
              className="btn-remover-arquivo"
              onClick={onRemoverArquivo}
              disabled={loading}
            >
              ✖
            </button>
          </div>
        )}
      </div>

      <button
        className="btn-enviar"
        onClick={onEnviar}
        disabled={loading || !arquivo}
      >
        {loading ? '⏳ Analisando...' : '✅ ENVIAR'}
      </button>

      {error && <div className="error-message">{error}</div>}

      {loading && (
        <div className="loading-message">
          <span>⏳</span>
          <span>Processando documento... Isso pode levar alguns minutos.</span>
        </div>
      )}
    </div>
  );
};

export default FormSection;